//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'
import { resolveMediaUrl } from '@/utils/mediaUrl'
import { buildMeanAndExampleHtml, MEAN_HIGHLIGHT_STYLE } from '@/utils/wordHighlight'
import { isTrialAccount, isWordTrialLimited, TRIAL_WORD_LIMIT, trialWordLimitToast } from '@/utils/trialAccess'

const HIGHLIGHT_STYLE = MEAN_HIGHLIGHT_STYLE

export default {
  data () {
    return {
      words: [],
      currentIndex: 0,
      finished: false,
      loading: true,
      submitting: false,
      resultTotal: 0,
      sessionId: null,
      reviewType: 'intelligent',
      stats: { known: 0, fuzzy: 0, unknown: 0 },
      highlightStyle: HIGHLIGHT_STYLE,
      wordNavigateStack: [],
      trialLimited: false
    }
  },
  computed: {
    currentWord () {
      return this.words[this.currentIndex] || {}
    },
    navTitle () {
      if (!this.words.length) return '智能复习'
      if (this.wordNavigateStack.length > 0) return this.currentWord.word_name || '单词详情'
      return `智能复习 ${this.currentIndex + 1}/${this.words.length}`
    },
    multiWordParts () {
      const name = this.currentWord.word_name
      if (!name) return []
      return String(name).split(/\s+/).filter(Boolean)
    },
    emptyHint () {
      if (this.reviewType === 'error') return '错题本为空，请先做练习测试'
      if (this.reviewType === 'star') return '暂无重点单词，复习时点击「标为重点」'
      return '暂无待复习单词，请先去学习课表学新词'
    },
    hasAnalysis () {
      return !!(this.processedWordSplit || this.processedWordIde || this.processedExample)
    },
    processedMean () {
      const mean = this.currentWord.mean
      const example = this.currentWord.example
      if (!mean) return ''
      return buildMeanAndExampleHtml(mean, example, { style: this.highlightStyle }).processedMean
    },
    processedWordSplit () {
      const raw = this.currentWord.word_split
      if (!raw) return ''
      const text = String(raw).replace(/<[^>]+>/g, '')
      const plusStyle = this.wordPartPlusStyle()
      const chipStyle = this.wordPartChipStyle(false)
      return text.split('+')
        .map(p => p.trim())
        .filter(Boolean)
        .map(part => '<span class="word-part" style="' + chipStyle + '">' + this.escapeHtml(part) + '</span>')
        .join('<span style="' + plusStyle + '">+</span>')
    },
    processedWordIde () {
      const raw = this.currentWord.word_ide
      if (!raw) return ''
      const text = String(raw).replace(/<[^>]+>/g, '')
      const plusStyle = this.wordPartPlusStyle()
      const that = this
      return text.split(/\s*\+\s*/)
        .map(seg => that.formatIdeSegment(seg))
        .join('<span style="' + plusStyle + '">+</span>')
    },
    processedExample () {
      const mean = this.currentWord.mean
      const example = this.currentWord.example
      if (!example) return ''
      if (!mean) return this.escapeHtml(example)
      return buildMeanAndExampleHtml(mean, example, { style: this.highlightStyle }).processedExample
    }
  },
  async created () {
    this.reviewType = this.$route.query.review_type || 'intelligent'
    try {
      const sessionRes = await this.$ajax.post(newApi.sessionStart, { session_type: 'review' })
      this.sessionId = sessionRes && sessionRes.session_id
      await this.loadWords()
    } catch (e) {
      this.loading = false
      this.toast('加载失败，请重试')
    }
  },
  methods: {
    escapeHtml (unsafe) {
      return String(unsafe || '').replace(/[&<"'>]/g, match => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[match]))
    },
    wordPartChipStyle (isLink) {
      const base = 'display:inline-block;font-weight:600;line-height:1.35;margin:0 1px;border-radius:4px;vertical-align:baseline;'
      if (isLink) {
        return base + 'color:#1989fa;background:#eef5ff;border:1px solid rgba(25,137,250,0.45);cursor:pointer;text-decoration:underline;text-underline-offset:2px;text-decoration-thickness:1px;'
      }
      return base + 'color:#555;background:#f4f7fb;border:1px solid #dde4ec;'
    },
    wordPartPlusStyle () {
      return 'color:#b0bac5;font-weight:500;font-size:15px;margin:0 3px;'
    },
    formatIdeSegment (segment) {
      const trimmed = segment.trim()
      const match = trimmed.match(/^(\w+)((?:[(（][^)）]+[)）]).*|(?:英文|拼音|象形|形象|音标|词根|口诀).*)$/)
      if (!match) return this.escapeHtml(trimmed)
      const word = match[1]
      const rest = match[2]
      const isEnglish = /^(?:[(（]英文[)）]|英文)/.test(rest)
      const escapedWord = this.escapeHtml(word)
      const chip = isEnglish
        ? '<span class="word-part word-part--link word-ide-link" style="' + this.wordPartChipStyle(true) + '" data-word="' + escapedWord + '">' + escapedWord + '</span>'
        : '<span class="word-part" style="' + this.wordPartChipStyle(false) + '">' + escapedWord + '</span>'
      return chip + this.escapeHtml(rest)
    },
    onWordIdeClick (e) {
      const link = e.target.closest('.word-part--link')
      if (link && link.dataset.word) {
        e.preventDefault()
        this.jumpToEnglishWord(link.dataset.word)
      }
    },
    onMultiWordClick (part) {
      const word = String(part || '').replace(/^[^a-zA-Z]+|[^a-zA-Z]+$/g, '')
      if (!word) return
      this.jumpToEnglishWord(word)
    },
    saveWordNavigateState () {
      this.wordNavigateStack.push({
        words: this.words.map(w => ({ ...w })),
        currentIndex: this.currentIndex
      })
    },
    restoreWordNavigateState () {
      const prev = this.wordNavigateStack.pop()
      if (!prev) return false
      this.words = prev.words
      this.currentIndex = prev.currentIndex
      return true
    },
    jumpToEnglishWord (englishWord) {
      this.saveWordNavigateState()
      this.$ajax.get(this.$api.messageMessageBoardgetByWord + '?word=' + encodeURIComponent(englishWord) + '&type=back').then(response => {
        if (response && response.length > 0) {
          const hit = response[0]
          const pkId = hit.id || hit.wordId
          if (!pkId) {
            this.restoreWordNavigateState()
            this.toast('未找到单词「' + englishWord + '」')
            return
          }
          return this.$ajax.get(this.$api.getPmsPmsWordsById + '?pkId=' + pkId).then(detail => {
            if (!detail && !hit.english && !hit.word_name) {
              this.restoreWordNavigateState()
              this.toast('未找到单词「' + englishWord + '」')
              return
            }
            const mapped = this.mapWordDetail(detail || hit)
            this.words = [mapped]
            this.currentIndex = 0
          })
        }
        this.restoreWordNavigateState()
        this.toast('未找到单词「' + englishWord + '」')
      }).catch(() => {
        this.restoreWordNavigateState()
        this.toast('加载单词失败，请稍后重试')
      })
    },
    mapWordDetail (w) {
      const img = w.pmsImg || w.pms_img || ''
      return {
        word_id: w.id || w.wordId || w.word_id,
        word_name: w.english || w.word_name || w.wordName,
        yinbiao: w.yinbiao,
        meibiao: w.meibiao,
        tts_en: w.ttsEn || w.tts_en,
        tts_am: w.ttsAm || w.tts_am,
        mean: w.mean,
        word_split: w.wordSplit || w.word_split,
        word_ide: w.wordIde || w.word_ide,
        example: w.example,
        pms_img: img ? resolveMediaUrl(img) : '',
        model_sentence: w.modelSentence || w.model_sentence,
        model_text: w.modelText || w.model_text,
        review_stage: w.review_stage || 0,
        is_star: w.is_star || false,
        _linkedDetail: true
      }
    },
    toast (msg) {
      if (this.$vux) this.$vux.toast.text(msg)
      else if (this.$toast) this.$toast(msg)
    },
    playAudio (url, word, type) {
      let src = url
      if (!src && word) {
        src = `https://dict.youdao.com/dictvoice?audio=${encodeURIComponent(word)}&type=${type || 1}`
      }
      if (!src) return
      const el = this.$refs.audioEl
      if (!el) return
      el.src = src
      el.play().catch(() => {})
    },
    loadWords () {
      const categoryId = this.$route.query.categoryId
      const queryPower = this.$route.query.isWordPower
      this.trialLimited = isTrialAccount() || isWordTrialLimited(queryPower)
      let countUrl = newApi.reviewTodayCount
      if (categoryId) countUrl += '?category_id=' + categoryId
      return this.$ajax.get(countUrl).then(countRes => {
        if (countRes && countRes.trial_limited) {
          this.trialLimited = true
        }
        const total = (countRes && countRes.total_count) || 0
        let limit = total > 0 ? Math.min(total, 200) : 50
        if (this.trialLimited) {
          limit = Math.min(limit, TRIAL_WORD_LIMIT)
        }
        let url = newApi.reviewWords + '?review_type=' + this.reviewType + '&limit=' + limit
        if (categoryId) url += '&category_id=' + categoryId
        return this.$ajax.get(url)
      }).then(res => {
        let list = (res && res.words) || []
        if (this.trialLimited) {
          // 未开通：固定按 word_id 取前 N，不随接口轮换/乱序变相无限学
          list = list.slice().sort((a, b) => Number(a.word_id || 0) - Number(b.word_id || 0))
          if (list.length > TRIAL_WORD_LIMIT) {
            list = list.slice(0, TRIAL_WORD_LIMIT)
          }
        }
        this.words = list.map(w => ({
          ...w,
          pms_img: w.pms_img ? resolveMediaUrl(w.pms_img) : ''
        }))
        this.loading = false
        if (this.trialLimited && this.words.length) {
          this.toast(trialWordLimitToast())
        }
      })
    },
    goBack () {
      if (this.wordNavigateStack.length > 0) {
        this.restoreWordNavigateState()
        return
      }
      const categoryId = this.$route.query.categoryId
      const from = this.$route.query.from
      // 错题本复习：回到错题本列表
      if (this.reviewType === 'error') {
        this.$router.push({
          path: '/reviewErrorBook_display',
          query: { hideTrans: 'true', from, categoryId }
        })
        return
      }
      // 从「我的」直达重点词：回我的
      if (from === 'mine' && this.reviewType === 'star') {
        this.$router.push({ path: '/mine', query: { hideTrans: 'true' } })
        return
      }
      // 默认回到智能复习首页（保留来源，便于再返回 Tab）
      this.$router.push({
        path: '/reviewHome_display',
        query: {
          categoryId,
          hideTrans: 'true',
          from,
          isWordPower: this.$route.query.isWordPower
        }
      })
    },
    goPrev () {
      if (this.wordNavigateStack.length > 0) {
        this.restoreWordNavigateState()
        return
      }
      if (this.currentIndex > 0) this.currentIndex--
    },
    submit (result) {
      if (this.submitting || !this.sessionId) return
      if (this.wordNavigateStack.length > 0) {
        // 联想基础词学完后回到原复习词，继续当前进度（不整页退出）
        this.restoreWordNavigateState()
        this.toast('已返回复习')
        return
      }
      const word = this.currentWord
      if (!word.word_id) return
      this.submitting = true
      this.$ajax.post(newApi.reviewSubmit, {
        word_id: word.word_id,
        result,
        duration: 15,
        session_id: this.sessionId
      }).then(() => {
        if (result === 'known') this.stats.known++
        else if (result === 'fuzzy') this.stats.fuzzy++
        else this.stats.unknown++
        if (this.currentIndex < this.words.length - 1) {
          this.currentIndex++
        } else {
          this.finished = true
          this.resultTotal = this.words.length
          this.endSession()
        }
      }).catch(() => {
        this.toast('提交失败，请重试')
      }).finally(() => {
        this.submitting = false
      })
    },
    endSession () {
      if (!this.sessionId) return
      this.$ajax.post(newApi.sessionEnd, {
        session_id: this.sessionId,
        word_count: this.words.length,
        correct_count: this.stats.known + this.stats.fuzzy,
        wrong_count: this.stats.unknown
      }).catch(() => {})
    },
    toggleStar () {
      const word = this.currentWord
      if (!word.word_id) return
      const next = !word.is_star
      this.$ajax.post(newApi.reviewToggleStar, { word_id: word.word_id, is_star: next }).then(() => {
        this.$set(this.words[this.currentIndex], 'is_star', next)
        this.toast(next ? '已标为重点' : '已取消重点')
      }).catch(() => { this.toast('操作失败') })
    },
    goPractice () {
      this.$router.push({ path: '/practice?hideTrans=true' })
    },
    goStudy () {
      this.$router.push({ path: '/wordIndex?hideTrans=true' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/review/practice.vue